import { httpClient } from '../http/httpClient'

export interface TransactionChartResponse {
  data: {
    date: string
    total: number
    count: number
    [key: string]: string | number
  }[]
}

export interface TransactionChartParams {
  sellerIds?: string
  customerIds?: string
  teamIds?: string
  startDate?: string
  endDate?: string
  status?: string
  type?: string
}

export async function transactionChart(
  params: TransactionChartParams | undefined,
) {
  const { data } = await httpClient.get<TransactionChartResponse>(
    '/transaction/chart',
    {
      params,
    },
  )

  return data
}
